export function getMeetingLink(session) {
  if (!session || session.status !== "scheduled") return null;
  if (session.meeting_link) return session.meeting_link;
  if (session.session_id) {
    return `https://meet.jit.si/mycoaching-${session.session_id}`;
  }
  return null;
}